import { useState } from 'react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent, Button, Textarea, Label } from '@/components/ui'
import { Link2 } from 'lucide-react'

export function UrlEncoderDecoder() {
  const [input, setInput] = useState('')
  const [output, setOutput] = useState('')

  const handleEncode = () => {
    setOutput(encodeURIComponent(input))
  }

  const handleDecode = () => {
    try {
      setOutput(decodeURIComponent(input))
    } catch (error) {
      setOutput('Invalid URL encoding')
    }
  }

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20">
            <Link2 className="h-6 w-6 text-blue-500" />
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">URL Encoder/Decoder</h1>
            <p className="text-muted-foreground">Encode or decode URLs</p>
          </div>
        </div>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <Card className="glass">
          <CardHeader>
            <CardTitle>Input</CardTitle>
            <CardDescription>Enter the URL to encode or decode</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label>URL</Label>
              <Textarea
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="e.g., https://example.com/?q=hello world"
                className="h-48"
              />
            </div>
            <div className="flex gap-2">
              <Button onClick={handleEncode}>Encode</Button>
              <Button onClick={handleDecode}>Decode</Button>
            </div>
          </CardContent>
        </Card>

        <Card className="glass">
          <CardHeader>
            <CardTitle>Output</CardTitle>
            <CardDescription>Result</CardDescription>
          </CardHeader>
          <CardContent>
            <Textarea
              value={output}
              readOnly
              className="h-48 font-mono"
            />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
